import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "success-page" }
const _hoisted_2 = { class: "success-card" }
const _hoisted_3 = { class: "success-icon" }
const _hoisted_4 = { class: "success-actions" }
const _hoisted_5 = { class: "mt-4" }

import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useModalStore } from "@/shared/stores/modal";
import SaveSurveyTemplateModal from "@/modules/provider/components/SaveSurveyTemplateModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentSurveySuccess',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const modal = useModalStore();

const submittedSurveyId = computed(() => {
  const raw =
    (route.query as any)?.id ??
    (route.params as any)?.id ??
    "";
  const n = Number(raw);
  return Number.isInteger(n) ? n : null;
});

function handleSaveAsTemplate() {
  modal.open(
    SaveSurveyTemplateModal,
    {
      surveyId: submittedSurveyId.value,
      onSave: async (payload: any) => {
        // TODO: wire up API when endpoint is available.
        // eslint-disable-next-line no-console
        console.log("save survey as template payload:", payload);
      },
    },
    { title: "Save as template" },
  );
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "44",
          color: "success"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("mdi-check-circle-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "success-title" }, "Survey submitted successfully", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "success-subtitle" }, " Your survey responses for this appointment have been submitted. You can save this survey as a template for future reuse. ", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(AppButtonFlat, {
            color: "primary",
            "prepend-icon": "mdi-content-save-outline",
            onClick: handleSaveAsTemplate
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Save as template ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(AppButtonFlat, {
        variant: "outlined",
        block: "",
        "prepend-icon": "mdi-arrow-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'vendor.dashboard' })))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" Back to Dashboard ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})